module.exports = __webpack_public_path__ + "static/media/Ouro.61c2d885.svg";